// import {logIn} from '../lib/homePageServices';

const initState = {
  homePageDataFetched: false,
  homePageFilterModalVisible: false,
  homePageSortBy: {value: 'FEATURED', text: 'Featured'},
  homePageSearchKeyWords: '',
  homePageDeals: [],
  homePageFilteredDeals: [],
  homePagePriceRangeTextBoxes: {
    errors: [],
    // displayed are values shown in textbox.
    // longTerm are values are persisted when user navigates away
    // and comes back later.
    // see homePage constructor and handleApply methods for more info
    lowLongTerm: '',
    lowDisplayed: '',
    highLongTerm: '',
    highDisplayed: '',
  },
  // Todo: Refactor categories into Map instead of arrays
  homePageLaptopCategories: {
    priceRange: {
      low: -1,
      high: -1
    },
    manufacturers: [],
    screenSizes: [],
    panelTypes: [
      {panelType: 'IPS', checked: false},
      {panelType: 'TN', checked: false}
    ],
    resolutions: [],
    touchscreen: {
      checked: false
    },
    weights: [
      {type: 'Feather', checked: false},
      {type: 'Light', checked: false},
      {type: 'Medium', checked: false},
      {type: 'Heavy', checked: false},
      {type: 'Brick', checked: false}
    ],
    cpuManufacturers: [
      {manufacturer: 'AMD', checked: false},
      {manufacturer: 'Intel', checked: false}
    ],
    cpuCores: [
      {cores: '1', checked: false},
      {cores: '2', checked: false},
      {cores: '4', checked: false},
      {cores: '6+', checked: false}
    ],
    ramSizes: [
      {ramSize: 1, checked: false},
      {ramSize: 2, checked: false},
      {ramSize: 4, checked: false},
      {ramSize: 8, checked: false},
      {ramSize: 16, checked: false},
      {ramSize: 32, checked: false}
    ],
    hdTypes: [
      {type: 'SSD', checked: false},
      {type: 'HDD', checked: false},
      {type: 'Hybrid', checked: false},
      {type: 'SSD + HDD/Hybrid', checked: false}
    ],
    hdSizes: [
      {hdSize: 128, checked: false},
      {hdSize: 256, checked: false},
      {hdSize: 512, checked: false},
      {hdSize: 1000, checked: false},
      {hdSize: 2000, checked: false}
    ],
    gpuTypes: [
      {type: 'Integrated', checked: false},
      {type: 'Discrete', checked: false}
    ],
    gpuManufacturers: [
      {manufacturer: 'AMD', checked: false},
      {manufacturer: 'Intel', checked: false},
      {manufacturer: 'Nvidia', checked: false}
    ],
    gpuRamSizes: [],
    operatingSystems: [
      {type: 'Windows', checked: false},
      {type: 'MacOS', checked: false},
      {type: 'ChromeOS', checked: false},
      {type: 'Linux', checked: false}
    ],
    portTypes: [],
    opticalDrive: {
      checked: false
    },
    webcam: {
      checked: false
    },
    bluetooth: {
      checked: false
    }
  },
  homePageFilters: {
    shouldFilter: false,

  },

  signInModal: {signInEmail: '', signInPassword: '', signInIsVisible: false, signInError: false},
  signUpModal: {signUpFirstName: '', signUpLastName: '', signUpEmail: '', signUpSubmitEnabled: false, signUpIsVisible: false, signUpError: false, signUpSuccess: false, signUpWarning: false},
  registrationModal: {registrationCode: '', registrationFirstName: '', registrationLastName: '', registrationEmail: '', registrationPassword: '', registrationIsVisible: false, registrationError: false},

  specsModalVisible: false,
  currentLaptop: ''
};
export const HOMEPAGE_DATAFETCHED_UPDATE = 'HOMEPAGE_DATAFETCHED_UPDATE';
export const updateHomePageDataFetched = (val) => ({type: HOMEPAGE_DATAFETCHED_UPDATE, payload: val});

export const HOMEPAGE_FILTERMODAL_UPDATE = 'HOMEPAGE_FILTERMODAL_UPDATE';
export const updateHomePageFilterModal = (val) => ({type: HOMEPAGE_FILTERMODAL_UPDATE, payload: val});

export const HOMEPAGE_SORTBY_UPDATE = 'HOMEPAGE_SORTBY_UPDATE';
export const updateHomePageSortBy = (val) => ({type: HOMEPAGE_SORTBY_UPDATE, payload: val});

export const HOMEPAGE_SEARCHKEYWORDS_UPDATE = 'HOMEPAGE_SEARCHKEYWORDS_UPDATE';
export const updateHomePageSearchKeyWords = (val) => ({type: HOMEPAGE_SEARCHKEYWORDS_UPDATE, payload: val});

export const HOMEPAGE_DEALS_UPDATE = 'HOMEPAGE_DEALS_UPDATE';
export const updateHomePageDeals = (val) => ({type: HOMEPAGE_DEALS_UPDATE, payload: val});

export const HOMEPAGE_FILTEREDDEALS_UPDATE = 'HOMEPAGE_FILTEREDDEALS_UPDATE';
export const updateHomePageFilteredDeals = (val) => ({type: HOMEPAGE_FILTEREDDEALS_UPDATE, payload: val});

export const HOMEPAGE_PRICERANGETEXTBOXES_UPDATE = 'HOMEPAGE_PRICERANGETEXTBOXES_UPDATE';
export const updateHomePagePriceRangeTextBoxes = (val) => ({type: HOMEPAGE_PRICERANGETEXTBOXES_UPDATE, payload: val});

export const HOMEPAGE_FILTERCATEGORIES_UPDATE = 'HOMEPAGE_FILTERCATEGORIES_UPDATE';
export const updateHomePageFilterCategories = (val) => ({type: HOMEPAGE_FILTERCATEGORIES_UPDATE, payload: val});



export const SIGNIN_MODAL_LOAD = 'SIGNIN_MODAL_LOAD';
export const SIGNIN_MODAL_UPDATE = 'SIGNIN_MODAL_UPDATE';
export const loadSignInModal = () => ({type: SIGNIN_MODAL_LOAD, payload: SIGNIN_MODAL_LOAD});
export const updateSignInModal = (val) => ({type: SIGNIN_MODAL_UPDATE, payload: val});

export const SIGNUP_MODAL_UPDATE = 'SIGNUP_MODAL_UPDATE';
export const updateSignUpModal = (val) => ({type: SIGNUP_MODAL_UPDATE, payload: val});

export const REGISTRATION_MODAL_UPDATE = 'REGISTRATION_MODAL_UPDATE';
export const updateRegistrationModal = (val) => ({type: REGISTRATION_MODAL_UPDATE, payload: val});


export const HOMEPAGE_SPECS_MODAL_UPDATE = "HOMEPAGE_SPECS_MODAL_UPDATE";
export const updateHomePageSpecsModal = (val) => ({type: HOMEPAGE_SPECS_MODAL_UPDATE, payload: val});

export const HOMEPAGE_CURRENT_LAPTOP_UPDATE = "HOMEPAGE_CURRENT_LAPTOP_UPDATE";
export const updateHomePageCurrentLaptop = (val) => ({type: HOMEPAGE_CURRENT_LAPTOP_UPDATE, payload: val});


export const getSignInDisplayModal = () => {
  return (dispatch) => {dispatch(loadSignInModal())};
}

export const toggleSignInDisplayModal = () => {
  return (dispatch, getState) => {
    const signInModalState = getState().homePage.signInModal;
    const visible = signInModalState.signInIsVisible;
    const toggled = {...signInModalState, signInIsVisible: !visible};
    dispatch(updateSignInModal(toggled));
  };
};

export const setSignInFormError = () => {
  return (dispatch, getState) => {
    let signInModalState = getState().homePage.signInModal;
    signInModalState = {...signInModalState, signInError: true};
    dispatch(updateSignInModal(signInModalState));
  }
}

export const clearSignInForm = () => {
  return (dispatch) => {
    const signInModalState = {signInEmail: '', signInPassword: '', signInIsVisible: false, signInError: false};
    dispatch(updateSignInModal(signInModalState));
  }
}


export const toggleSignUpDisplayModal = () => {
  return (dispatch, getState) => {
    const signUpModalState = getState().homePage.signUpModal;
    const visible = signUpModalState.signUpIsVisible;
    const toggled = {...signUpModalState, signUpIsVisible: !visible};
    dispatch(updateSignUpModal(toggled));
  };
};

export const setSignUpFormError = () => {
  return (dispatch, getState) => {
    let signUpModalState = getState().homePage.signUpModal;
    signUpModalState = {...signUpModalState, signUpError: true, signUpSuccess: false, signUpWarning: false};
    dispatch(updateSignUpModal(signUpModalState));
  }
}

export const setSignUpFormSuccess = () => {
  return (dispatch, getState) => {
    let signUpModalState = getState().homePage.signUpModal;
    signUpModalState = {...signUpModalState, signUpSuccess: true, signUpError: false, signUpWarning: false};
    dispatch(updateSignUpModal(signUpModalState));
  }
}

export const setSignUpFormWarning = () => {
  return (dispatch, getState) => {
    let signUpModalState = getState().homePage.signUpModal;
    signUpModalState = {...signUpModalState, signUpWarning: true, signUpError: false, signUpSuccess: false};
    dispatch(updateSignUpModal(signUpModalState));
  }
}

export const clearSignUpForm = () => {
  return (dispatch) => {
    const signUpModalState = {signUpFirstName: '', signUpLastName: '', signUpEmail: '', signUpSubmitEnabled: false, signUpIsVisible: false, signUpError: false, signUpSuccess: false, signUpWarning: false};
    dispatch(updateSignUpModal(signUpModalState));
  }
}

export const toggleRegistrationDisplayModal = () => {
  return (dispatch, getState) => {
    const registrationModalState = getState().homePage.registrationModal;
    const visible = registrationModalState.registrationIsVisible;
    const toggled = {...registrationModalState, registrationIsVisible: !visible};
    dispatch(updateRegistrationModal(toggled));
  };
};

export const setRegistrationFormError = () => {
  return (dispatch, getState) => {
    let registrationModalState = getState().homePage.registrationModal;
    registrationModalState = {...registrationModalState, registrationError: true};
    dispatch(updateRegistrationModal(registrationModalState));
  }
}

export const clearRegistrationForm = () => {
  return (dispatch) => {
    const registrationModalState = {registrationCode: '', registrationFirstName: '', registrationLastName: '', registrationEmail: '', registrationPassword: '', registrationIsVisible: false, registrationError: false};
    dispatch(updateRegistrationModal(registrationModalState));
  }
}

export default (state = initState, action) => {
  switch (action.type) {
    case HOMEPAGE_DATAFETCHED_UPDATE:
      return {...state, homePageDataFetched: action.payload};
    case HOMEPAGE_FILTERMODAL_UPDATE:
      return {...state, homePageFilterModalVisible: action.payload};
    case HOMEPAGE_SORTBY_UPDATE:
      return {...state, homePageSortBy: action.payload};
    case HOMEPAGE_SEARCHKEYWORDS_UPDATE:
      return {...state, homePageSearchKeyWords: action.payload};
    case HOMEPAGE_DEALS_UPDATE:
      return {...state, homePageDeals: action.payload};
    case HOMEPAGE_FILTEREDDEALS_UPDATE:
      return {...state, homePageFilteredDeals: action.payload};
    case HOMEPAGE_PRICERANGETEXTBOXES_UPDATE:
      return {...state, homePagePriceRangeTextBoxes: action.payload};
    case HOMEPAGE_FILTERCATEGORIES_UPDATE:
      return {...state, homePageLaptopCategories: action.payload};
    case SIGNIN_MODAL_LOAD:
      return {...state, signInModal: action.payload };
    case SIGNIN_MODAL_UPDATE:
      return {...state, signInModal: action.payload};
    case SIGNUP_MODAL_UPDATE:
      return {...state, signUpModal: action.payload};
    case REGISTRATION_MODAL_UPDATE:
      return {...state, registrationModal: action.payload};
    case HOMEPAGE_SPECS_MODAL_UPDATE:
      return {...state, specsModalVisible: action.payload};
    case HOMEPAGE_CURRENT_LAPTOP_UPDATE:
      return {...state, currentLaptop: action.payload};
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/homePageReducer.js